import { $gettext } from '@/config/gettext'

const primary = [
  {
    label: $gettext('Packages'),
    routeName: 'Private/Package'
  },
  {
    label: $gettext('Accommodation'),
    routeName: 'Private/Hotel'
  },
  {
    label: $gettext('Transport'),
    routeName: 'Private/Bus'
  },
  {
    label: $gettext('Bookings'),
    routeName: 'Private/Bookings'
  },
  {
    label: $gettext('Account'),
    routeName: 'Private/Account'
  }
]

const secondary = [
  // {
  //   label: 'contact',
  //   routeName: 'Private/Contact',
  //   icon: require('@/assets/images/icons/contact.png')
  // },
  // {
  //   label: 'despre noi',
  //   routeName: 'Private/About',
  //   icon: require('@/assets/images/icons/despre.png')
  // },
  // {
  //   label: 'cont',
  //   routeName: 'Private/Account',
  //   icon: require('@/assets/images/icons/cont.png')
  // },
  {
    label: $gettext('log out'),
    routeName: 'Private/Logout',
    icon: 'power'
  }
]

export {
  primary,
  secondary
}
